"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sleep;

function sleep(interval) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, Math.max(interval, 0));
  });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJzbGVlcCIsImludGVydmFsIiwiUHJvbWlzZSIsInJlc29sdmUiLCJzZXRUaW1lb3V0IiwiTWF0aCIsIm1heCJdLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9zbGVlcC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBzbGVlcChpbnRlcnZhbDogbnVtYmVyKTogUHJvbWlzZTx2b2lkPiB7XG4gIHJldHVybiBuZXcgUHJvbWlzZShyZXNvbHZlID0+IHNldFRpbWVvdXQocmVzb2x2ZSwgTWF0aC5tYXgoaW50ZXJ2YWwsIDApKSk7XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBZSxTQUFTQSxLQUFULENBQWVDLFFBQWYsRUFBZ0Q7RUFDN0QsT0FBTyxJQUFJQyxPQUFKLENBQVksVUFBQUMsT0FBTztJQUFBLE9BQUlDLFVBQVUsQ0FBQ0QsT0FBRCxFQUFVRSxJQUFJLENBQUNDLEdBQUwsQ0FBU0wsUUFBVCxFQUFtQixDQUFuQixDQUFWLENBQWQ7RUFBQSxDQUFuQixDQUFQO0FBQ0QifQ==